<template>
    <RedesignBaseCounterCard
        :widget="data"
        :show-text="showText"
        :display-border="displayBorder"
        :card-text="cardText"
        :card-value="cardValue"
        :icon="CARD_ICON"
        :icon-color="iconColor"
        :loading="isLoading"
        class="total-outgoing-calls-card"
    />
</template>

<script setup lang="ts">
/* Total Outgoing Calls Widget */
import RedesignBaseCounterCard from '@/components/RedesignComponents/Cards/RedesignBaseCounterCard.vue'
import { WidgetExtended } from '@/types/dashboard'
import { computed } from 'vue'
import useWidgetDataWithRefreshInterval from '@/composables/useWidgetDataWithRefreshInterval'
import { ObjectAnyType } from '@/types/generic'
import { activeLayoutColors } from '@/composables/globalData/useLayouts'

const CARD_ICON = 'PhoneOutgoing'

const props = withDefaults(
    defineProps<{
        data: WidgetExtended
        editable?: boolean
        onEditMode?: boolean
        showText?: boolean
        displayBorder?: boolean
        queue?: boolean
    }>(),
    {
        showText: true,
        displayBorder: true,
    })


/* Composable */
const {
    data: widgetData,
    isLoading
} = useWidgetDataWithRefreshInterval(props, 'data')
/* Data */
// const cardValue = ref('')

/* Computed */
const cardText = computed(() => props.data.Title)
const cardValue = computed(() => {
    const resData = (widgetData.value || []) as Array<ObjectAnyType>
    const resValue = resData[0] || {}
    const firstKey = Object.keys(resValue)[0]
    return resValue[firstKey] || 0
})
const iconColor = computed(() => {
    return props.data.WidgetLayout?.colors?.fonts || activeLayoutColors.value.mainTextColor
})

</script>
